var React = require('react');

function Videos (props) {
    return React.createElement("svg",props,React.createElement("path",{"d":"M7.00156 0.900024C3.20156 0.900024 0.101562 4.00002 0.101562 7.80002C0.101562 11.6 3.20156 14.7 7.00156 14.7C10.8016 14.7 13.9016 11.6 13.9016 7.80002C13.9016 4.00002 10.8016 0.900024 7.00156 0.900024ZM10.4016 8.30002L5.50156 11.2C5.40156 11.3 5.30156 11.3 5.20156 11.3C5.10156 11.3 5.00156 11.3 4.90156 11.2C4.70156 11.1 4.60156 10.9 4.60156 10.7V4.90002C4.60156 4.70002 4.70156 4.50002 4.90156 4.40002C5.10156 4.30002 5.30156 4.30002 5.50156 4.40002L10.4016 7.30002C10.6016 7.40002 10.7016 7.60002 10.7016 7.80002C10.7016 8.00002 10.6016 8.20002 10.4016 8.30002Z"}));
}

Videos.defaultProps = {"width":"14","height":"15","viewBox":"0 0 14 15","fill":"none"};

module.exports = Videos;

Videos.default = Videos;
